/**
 * Make some properties optional.
 */
export type WithOptional<T, K extends keyof T> = Omit<T, K> &
  Partial<Pick<T, K>>;

/**
 * Make some properties required.
 */
export type WithRequired<T, K extends keyof T> = Omit<T, K> &
  Required<Pick<T, K>>;

/**
 * Recursive Partial, making any sub-properties optional.
 */
export type Subset<K> = {
  [attr in keyof K]?: K[attr] extends object
    ? Subset<K[attr]>
    : K[attr] extends object | null
    ? Subset<K[attr]> | null
    : K[attr] extends object | null | undefined
    ? Subset<K[attr]> | null | undefined
    : K[attr];
};

export type HasProperty<T, K extends PropertyKey> = T extends any
  ? K extends keyof T
    ? T
    : never
  : never;

export function ensureInt(num: string | number) {
  if (typeof num == "number") return num;
  return parseInt(num);
}
export function ensureFloat(num: string | number) {
  if (typeof num == "number") return num;
  return parseFloat(num);
}

export function notNull<T>(val: T | null | undefined): val is T {
  return val != null;
}

export function getDefineList<K>() {
  return function defineList<T extends { [index: string]: K }>(
    i: T
  ): { [k in keyof T]: K } {
    return i;
  }
}

export function isInList<const L extends readonly unknown[]>(
  item: unknown,
  list: L
): item is L[number] {
  return list.indexOf(item as any) !== -1;
}
